import React from 'react'
import { cn } from "@/storyblok/utils/cn";
import { defaultTitleClasses } from '@/library/utils/titleClasses';

export default function Title({title, titleColor="textLight", titleAs="h2", className=''}) {
  const TitleTag = titleAs;
  return (
    <>
      {title && (
        <TitleTag className={cn(className, defaultTitleClasses(titleColor))}>{title}</TitleTag>
      )}
    </>
  )
}

